import React from "react";
import { Stack, Typography, Divider, Box } from "@mui/material";
import { MetricCardData } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles, getBreakdownColors } from "../../styles";

interface BreakdownCardProps {
  data: MetricCardData;
}

export const BreakdownCard: React.FC<BreakdownCardProps> = ({ data }) => {
  const defaultColors = getBreakdownColors();
  const hasComparisonLabel = Boolean(data.comparison?.label);
  const breakdownCount = data.breakdown?.length ?? 0;

  return (
    <BaseCard data={data}>
      {hasComparisonLabel && (
        <Typography sx={operationsDashboardStyles.breakdownComparison}>
          {data.comparison?.label}
        </Typography>
      )}
      <Divider
        sx={{
          ...operationsDashboardStyles.divider,
          ...(!hasComparisonLabel && breakdownCount >= 4 && { mt: 0 }),
        }}
      />
      {data.breakdown && (
        <Stack>
          {data.breakdown.map((item, index) => (
            <Stack
              key={`${item.label}-${item.value}-${item.percentage}`}
              direction="row"
              sx={operationsDashboardStyles.breakdownItem}
            >
              <Typography sx={operationsDashboardStyles.breakdownLabel}>
                {item.label}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography sx={operationsDashboardStyles.comparisonValue}>
                  {item.value}
                </Typography>
                {item.percentage !== undefined && (
                  <Typography
                    sx={operationsDashboardStyles.breakdownPercentage}
                  >
                    ({item.percentage})
                  </Typography>
                )}
                <Box
                  sx={{
                    ...operationsDashboardStyles.breakdownIndicator,
                    bgcolor:
                      item.color ?? defaultColors[index % defaultColors.length],
                  }}
                />
              </Stack>
            </Stack>
          ))}
        </Stack>
      )}
    </BaseCard>
  );
};
